import { create } from 'zustand';
import { dashboardService } from '@/services/dashboardService';
import { showToast } from '@/lib/toast';

interface DashboardSummary {
    articles: {
        count: number;
        growthPercent: number | null;
    };
    comments: {
        count: number;
        growthPercent: number | null;
    };
    images: {
        count: number;
        growthPercent: number | null;
    };
    users: {
        count: number;
        growthPercent: number | null;
    };
    range: {
        current: {
            start: string;
            end: string;
        };
        previous: {
            start: string;
            end: string;
        };
    };
}

interface DashboardState {
    // State
    summary: DashboardSummary | null;
    isLoading: boolean;
    error: string | null;

    // Actions
    fetchSummary: () => Promise<void>;
    clearError: () => void;
    resetDashboard: () => void;
}

export const useDashboardStore = create<DashboardState>((set, _get) => ({
    // Initial state
    summary: null,
    isLoading: false,
    error: null,

    // Fetch dashboard summary
    fetchSummary: async () => {
        set({ isLoading: true, error: null });
        try {
            const summary: any = await dashboardService.getSummary();
            set({
                summary: summary.data,
                isLoading: false,
            });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Lỗi khi tải tóm tắt dashboard';
            set({ error: errorMessage, isLoading: false });
            showToast.error("Lỗi", errorMessage);
        }
    },

    // Clear error
    clearError: () => set({ error: null }),

    // Reset dashboard
    resetDashboard: () => set({
        summary: null,
        error: null,
    }),
}));
